import {InjectionToken} from '@angular/core';

export const EXPORT_CONFIG = new InjectionToken('mydocma-export-config');

export interface ExportConfig {
  apiUrl?: string;
}
